import Chart from 'chart.js';
import 'chartjs-plugin-labels';
import {
  ProgressChartConfiguration, DATASET_INDEX_CURRENT,
  DATASET_INDEX_TARGET, DATASET_INDEX_TRACKER
} from './ProgressChartConfiguration';

export interface ProgressChartData extends Chart.ChartData {
  labels: Array<string | string[]>;
  datasets: Chart.ChartDataSets[];
}

export class ProgressChartModel {
  chart: Chart;

  constructor (ctx: HTMLCanvasElement, options: ProgressChartConfiguration) {
    this.chart = new Chart(ctx, options);
  }

  get datasetCurrent (): Chart.ChartDataSets {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return this.chart.data?.datasets![DATASET_INDEX_CURRENT];
  }

  get datasetTarget (): Chart.ChartDataSets {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return this.chart.data?.datasets![DATASET_INDEX_TARGET];
  }

  get datasetTracker (): Chart.ChartDataSets {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return this.chart.data?.datasets![DATASET_INDEX_TRACKER];
  }
}
